import { logMethodCall } from '../utils/debug';

export function initMultiPlatformWidgets(context) {
  logMethodCall('initMultiPlatformWidgets');

  context.multiPlatformWidgets = context.multiPlatformWidgets || [];

  const widgets = document.querySelectorAll('.cleverpush-multi-platform-widget');
  if (!widgets.length) {
    return;
  }
  import('./index').then(({ default: MultiPlatformWidget }) => {
    for (let i = 0; i < widgets.length; i += 1) {
      const element = widgets[i];

      const widget = new MultiPlatformWidget(i, element, context.config, context.subscriptionManager, context.api);

      context.on(Event.SUBSCRIBED, () => {
        widget.reset(context.browserType !== 'facebook', true);
      });
      context.on(Event.UNSUBSCRIBED, () => {
        widget.reset(context.browserType !== 'facebook', false);
      });

      context.waitForInit().then(() => {
        if (element && element.dataset && element.dataset.platform === 'web-push' && context.browserType === 'facebook') {
          widget.show(false, false);
          return;
        }

        widget.subscriptionManager = context.subscriptionManager;
        context.subscriptionManager.isSubscribed().then((isSubscribed) => {
          widget.show(context.browserType !== 'facebook', isSubscribed);
        }).catch(() => {
          widget.show(context.browserType !== 'facebook', false);
        });
      }).catch(() => {
        widget.show(false, false);
      });

      context.multiPlatformWidgets.push(widget);
    }
  });
}
